import { Fill, Worksheet } from 'exceljs';

export function adjustColumnWidth(worksheet: Worksheet) {
  worksheet.columns.forEach(column => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, cell => {
      const contentLength = cell.value ? cell.value.toString().length : 0;
      if (contentLength > maxLength) {
        maxLength = contentLength;
      }
    });
    column.width = maxLength < 10 ? 10 : maxLength; // Set a minimum width
  });
}

const baseColors = ['FADADD', 'DFF5E1', 'D6F0F5', 'FFF7CC', 'FFE5CC'];

function lighten(hex: string, steps: number): string {
  const num = parseInt(hex, 16);
  let r = (num >> 16) & 0xff;
  let g = (num >> 8) & 0xff;
  let b = num & 0xff;

  const add = steps * 20;
  r = Math.min(255, r + add);
  g = Math.min(255, g + add);
  b = Math.min(255, b + add);

  return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
}

export function getFillByLevel(level: number): Fill {
  const baseIndex = level % baseColors.length;
  const baseColor = baseColors[baseIndex];

  const cycle = Math.floor(level / baseColors.length);

  const finalColor = cycle > 0 ? lighten(baseColor, cycle) : baseColor;

  const fill: Fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF' + finalColor },
  };
  return fill;
}
